import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from '../base';
import { CreateObject } from '../item';
import { Place } from './place';

import { PlaceType } from '../types';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

const _schema = {
    name: 'STRIPE',
    fields: [
        { name: 'place', type: 'objid' },
        { name: 'status', type: 'string', default: 'PA' },
        { name: 'account', type: 'string' },
    ],
    relate: [
        { direction: '>', target: 'PLACE', by: 'place', name: 'place', reason: 'place', child: false, class: PlaceType },
    ],
} as const;

const _StripeClass = CreateObject(_schema);
if (!_StripeClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class Stripe extends _StripeClass {
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null) {
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): Stripe {
        return this._Copy(store) as Stripe;
    }

    get status(): string | null {
        return this['__base__status'];
    }

    set status(value: string) {
        if (this.status == 'DE') {
            return; // cannot modify deleted items
        }

        if (this.status == value) {
            return;
        }

        this['__base__status'] = value;
        if (this.place) {
            if ((this.status == 'DE') && !this.Commited) {
                this.place.DelStripe(this);
            }
            else {
                this.place.DoRefresh(this.table);
            }
        }
    }

    get IsActive(): boolean {
        return this.status === 'AC' || this.status === 'PV';
    }

    get IsValid(): boolean {
        return !!this.status && this.status !== 'DE';
    }

    /** Changelog rows lack parent 1:N lists; register on link (see Preselect / TicketProduct). */
    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'place' && related instanceof Place){
            if (related === this.place){
                related.AddStripe(this);
            }
        }
    }
}
